module.exports = __webpack_public_path__ + "static/media/dolphin-ring_720x480.5ae6d08c.jpg";